export default __webpack_public_path__ + "static/media/bg21.30ca1beb.png";